import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { ActionReducerMap } from '@ngrx/store';

import { StockMovementContent, StockMovementSearchCriteria } from '@shared/models';

import { StockInformationAction, StockInformationActionTypes } from './stock-information.actions';
import { StockInformationStates } from './stock-information.states';

export const stockInformationMovementModuleReducers: ActionReducerMap<Partial<StockInformationStates>> = {
  stockInformationMovement: stockInformationMovementReducers
};

export interface StockInformationMovementState extends EntityState<StockMovementContent> {
  isLoading: boolean;
  criteriaObject: StockMovementSearchCriteria;
  totalElements: number;
  totalPages: number;
}

export const adapter: EntityAdapter<StockMovementContent> = createEntityAdapter<StockMovementContent>();

export const initialStockInformationMovementState: StockInformationMovementState = adapter.getInitialState({
  isLoading: false,
  criteriaObject: {
    page: 0,
    size: 20
  },
  totalElements: 0,
  totalPages: 0
});

export function stockInformationMovementReducers(
  state = initialStockInformationMovementState,
  action: StockInformationAction
): StockInformationMovementState {
  switch (action.type) {
    case StockInformationActionTypes.STOCK_INFORMATION_MOVEMENT_REQUEST:
      return {
        ...state,
        criteriaObject: action.payload.criteria
      };
    case StockInformationActionTypes.STOCK_INFORMATION_MOVEMENT_RESPONSE:
      return adapter.setAll(action.payload.content, {
        ...state,
        criteriaObject: {
          ...state.criteriaObject,
          page: action.payload.page,
          size: action.payload.size
        },
        totalElements: action.payload.totalElements,
        totalPages: action.payload.totalPages
      });
    case StockInformationActionTypes.STOCK_INFORMATION_MOVEMENT_RESET:
      return initialStockInformationMovementState;
    default: {
      return state;
    }
  }
}

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
